import { XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

export function getStdPieces(allStyles, formatXAxis, timeName, data){
  var p = [];
  if (!allStyles.hideGrid){
    p.push(<CartesianGrid strokeDasharray='3 3' />)
  }
  if (!allStyles.hideXAxis){
    p.push(<XAxis dataKey="name" tickFormatter={formatXAxis} stroke={allStyles.xColor}/>)
  }
  function formatYAxis(value){
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  if (!allStyles.hideYAxis){
    p.push(<YAxis domain={["auto", "auto"]} stroke={allStyles.yColor} tickFormatter={formatYAxis}/>)
  }

  const CustomTooltip = ({ active, payload, label } ) => {
    if (active && payload && payload.length) {
      var valueLines = payload.map((aPayload, index)=>{
        return <div className="desc">{aPayload.name} : {formatYAxis(aPayload.value.toFixed(2))}</div>
      })
//
      return (
        <div className="custom-tooltip">
          <div className="label">{timeName} : {formatXAxis(allStyles.hideXAxis ? data[label].name : label)}</div>
          {valueLines}        
        </div>
      );
    }
    return null;
  };
//
  if (!allStyles.hideToolTip){
    p.push(<Tooltip wrapperStyle={{fontSize:allStyles.fontSize}} content={<CustomTooltip />}/>)
  }
  if (!allStyles.hideLegend){
    p.push(<Legend wrapperStyle={{fontSize:allStyles.fontSize}} />)
  }
  return p;
}
